// src/lib/dealNaming.ts
// Phase-4 Runde 2a: war bisher lokal in DealDetail.tsx dupliziert -- jetzt auch von den 5
// Analyzer-Routen gebraucht (DealEditBar "Deal: <Name>", wenn der Analyzer per dealId im
// "Details ergaenzen"-Modus geoeffnet wird), deshalb hierher ausgelagert statt ein 6.
// Mal kopiert.
import type { QuickCheckObjektart } from "./quickCheckDraft";

export const OBJEKTART_LABEL: Record<QuickCheckObjektart, string> = {
  etw: "Eigentumswohnung",
  mfh: "Mehrfamilienhaus",
  efh: "Einfamilienhaus",
  gewerbe: "Gewerbeimmobilie",
  mixeduse: "Gemischt genutzte Immobilie",
};

/** Die generischen Default-Namen, die /check (Check.tsx) und die 5 Analyzer
 *  (SaveToPortfolioButton-Aufrufstellen) ohne Adresseingabe vergeben -- NICHT "ein eigener
 *  Name" im Sinne der Deal-Heading-Logik, auch wenn obj.name dann nicht leer ist. */
export function isAutoGeneratedDealName(name: string, objektart: QuickCheckObjektart): boolean {
  if (/^Schnell-Check( \d{5})?$/.test(name)) return true;
  const FALLBACK: Record<QuickCheckObjektart, string> = { etw: "ETW", mfh: "MFH Objekt", efh: "EFH Objekt", gewerbe: "Gewerbe Objekt", mixeduse: "Mixed-Use Objekt" };
  return name === FALLBACK[objektart];
}

/** Lesbare Deal-Ueberschrift ("Mehrfamilienhaus in Erfurt" statt "Schnell-Check 14476" oder
 *  der eigene Name, falls vergeben) -- dieselbe Prioritaet wie DealDetail.tsx's Heading:
 *  eigener Name > Objektart+Ort > nur Objektart. */
export function buildDealHeading(params: {
  name: string;
  objektart: QuickCheckObjektart;
  ort: string | null;
}): string {
  const hasCustomName = params.name.length > 0 && !isAutoGeneratedDealName(params.name, params.objektart);
  if (hasCustomName) return params.name;
  return params.ort ? `${OBJEKTART_LABEL[params.objektart]} in ${params.ort}` : OBJEKTART_LABEL[params.objektart];
}

/** Paket 28: im Schnell-Check gewählte Ortschaft (data.ort), wenn die PLZ mehrere Orte hat. */
export function gewaehlterOrt(data: unknown): string | null {
  const o = (data as { ort?: unknown } | null | undefined)?.ort;
  return typeof o === "string" && o.trim() ? o.trim().slice(0, 80) : null;
}
